export const PayDayAdvance = {
    path: '/pay_day_advances',
    name: 'pay_day_advances',
    component: () => import('@/views/Debt/AdvancePayPage.vue'),
    children: [
        {
            path: '/pay_day_advances/add',
            name: 'pay_day_advances.add',
            component: () => import('@/views/Debt/Form/PayDayAdvanceForm.vue'),
            props: {addAction: true}
        },
        {
            path: '/pay_day_advances/edit/:id',
            name: 'pay_day_advances.edit',
            component: () => import('@/views/Debt/Form/PayDayAdvanceForm.vue'),
            props: {updateAction: true}
        },
        {
            path: '/pay_day_advances/view/:id',
            name: 'pay_day_advances.view',
            component: () => import('@/views/Debt/Form/PayDayAdvanceForm.vue'),
            props: {viewAction: true}
        },
        {
            path: '/pay_day_advances/delete/:id',
            name: 'pay_day_advances.delete',
            component: () => import('@/views/Debt/Form/PayDayAdvanceForm.vue'),
            props: {deleteAction: true}
        },
        {
            path: '/pay_day_advances/:id/refunds/add',
            name: 'pay_day_advances.refunds.add',
            component: () => import('@/views/Debt/Form/RefundForm.vue'),
            props: {pay_day_advance: true}
        },

        {
            path: '/pay_day_advances/:id/refunds',
            name: 'pay_day_advances.refunds',
            component: () => import('@/views/Debt/RefundDetails.vue'),
            props: {pay_day_advance: true}
        },
        {
            path: '/pay_day_advances/report/pay_day_advance/:id',
            name: 'pay_day_advances.report',
            component: () => import('@/views/Debt/Form/ReportRefund.vue'),
            props: {pay_day_advance: true}
        },
        {
            path: '/pay_day_advances/set_decision/:id/:module',
            name: 'pay_day_advances.set_decision',
            component: () => import('@/views/Request/Components/SetDecision.vue'),
        },
        {
            path: '/pay_day_advances/timelines/:id/:module',
            name: 'pay_day_advances.timelines',
            component: () => import('@/views/Request/Components/ValidationTimelines.vue'),
        },
        {
            path: '/pay_day_advances/documents/:id',
            name: 'pay_day_advances.documents',
            component: () => import('@/views/Edms/Document/ModuleDocumentPage.vue'),
            props: {module: "PAY_DAY_ADVANCE"}
        },
        {
            path: '/pay_day_advances/template_applications/:id',
            name: 'pay_day_advances.template_applications',
            component: () => import('@/views/Edms/TemplateApplication/ModuleTemplateApplicationPage.vue'),
            props: {module: "PAY_DAY_ADVANCE"}
        },
    ]
}